import { useApi } from '../composables'
import http from '../composables/src/useHttp'
import type { CreateServicePayload, Service, UpdateServicePayload } from '../types/service'

export const getAllServices = () => {
  return useApi<Service[]>(http.get('/services'))
}

export const getServicesByOrganizationId = (organizationId: string) => {
  return useApi<Service[]>(http.get(`/services/organization/${organizationId}`))
}

export const createService = (data: CreateServicePayload) => {
  return useApi<Service>(http.post('/services', data))
}

export const updateService = (id: string, data: UpdateServicePayload) => {
  return useApi<Service>(http.patch(`/services/${id}`, data))
}

export const deleteService = (id: string) => {
  return useApi<{ id: string; message: string }>(http.delete(`/services/${id}`))
}

export const getService = (id: string) => {
  return useApi<Service>(http.get(`/services/${id}`))
}
